export const SET_LOGIN_STATE = 'SET_LOGIN_STATE';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';

export const SET_CURRENT_DIRECTORY = 'SET_CURRENT_DIRECTORY';
export const SET_CURRENT_DIRECTORY_CONTENTS = 'SET_CURRENT_DIRECTORY_CONTENTS';

export const SET_OBJECT_TYPE = 'SET_OBJECT_TYPE';

export const SET_DIRECTORY_STRUCTURE = 'SET_DIRECTORY_STRUCTURE';
export const SET_DIRECTORY_PERMISSIONS = 'SET_DIRECTORY_PERMISSIONS';

export const SET_RELATED_FILES = 'SET_RELATED_FILES';